import React, {Component} from 'react';
import ClassList from 'class-list';
import {connect} from 'react-redux';

import {togglePanel} from '../../actionCreators';

import Button from './Button';

class Wrapper extends Component {

    constructor(props) {
        super(props);

        const ControlsArea = document.getElementsByClassName('controls-area')[0];

        this.classList = ClassList(ControlsArea);
    }

    render() {
        return <Button {...this.props} />;
    }

    componentDidMount() {
        this.toggleClass(this.props.panelOpen);
    }

    componentDidUpdate(previousProps) {
        const {panelOpen} = this.props;

        if (previousProps.panelOpen === panelOpen) return;

        this.toggleClass(panelOpen);
    }

    toggleClass(panelOpen) {
        if (panelOpen) {
            this.classList.add('panel-open');
        } else {
            this.classList.remove('panel-open');
        }
    }

}

const mapStateToProps = ({panelOpen}) => ({panelOpen});

const mapDispatchToProps = dispatch => ({
    onClick: () => dispatch(togglePanel),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
